import React from "react";

const RemoveGuarantor = ({
  id,
  isRemoveGuarantorOpen,
  closeRemoveGuarantor,
  setIsWarningRemoveGuarantorOpen,
}) => {
  const handleCancelButtonCLick = () => {
    closeRemoveGuarantor();
  };

  const openWarningRemoveGuarantor = () => {
    closeRemoveGuarantor();

    setIsWarningRemoveGuarantorOpen(true);
  };

  return (
    <>
      <div
        id={id}
        className={`${
          isRemoveGuarantorOpen ? "flex" : "hidden"
        } flex items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="flex items-center justify-center w-full">
          <div className="relative bg-white shadow-lg rounded-sm w-[90%] max-w-[50%] mx-auto">
            <div className="mb-8 mx-auto items-center justify-center">
              <div className="flex items-center justify-between">
                <div className="text-[#000000] font-bold text-[20px] ml-5">
                  <p>Remove Guarantor</p>
                </div>
                <button
                  onClick={closeRemoveGuarantor}
                  type="button"
                  className="bg-transparent  rounded-lg text-sm ml-auto inline-flex items-center "
                  data-modal-toggle={id}
                >
                  <svg
                    width="61"
                    height="43"
                    viewBox="0 0 61 43"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_13891_3896)">
                      <path
                        d="M32.84 28L30.7 24.9L28.9 28H25.2L28.88 22.3L25.1 16.84H28.94L31.08 19.92L32.88 16.84H36.58L32.84 22.46L36.68 28H32.84Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_13891_3896">
                        <rect width="61" height="43" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </div>
              <div className="flex items-stretch mx-5 mt-5">
                <div className="">
                  <svg
                    className="h-full"
                    width="10"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="10" height="100%" fill="#074073" />
                  </svg>
                </div>

                <div className="bg-[#F6FAF4] flex-grow py-2 flex items-center">
                  <div className="text-[#074073] text-[16px] font-[400] mx-2">
                    <p>
                      Removing a guarantor is a permanent action and cannot be
                      undone. The guarantor and <br /> borrower will be notified
                      once this action is completed. Please ensure you have
                      informed the <br /> borrower of this decision before
                      proceeding.
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex items-center mt-5 mx-5">
                <div className="mr-5">
                  <button
                    onClick={handleCancelButtonCLick}
                    data-modal-toggle={id}
                    type="button"
                    className="text-[#074073] font-[500] rounded-[5px] text-[16px] px-10 py-2 text-center 
                    bg-[#FFFFFF] border border-[#074073]"
                  >
                    No, cancel
                  </button>
                </div>
                <button
                  onClick={openWarningRemoveGuarantor}
                  data-modal-toggle={id}
                  type="button"
                  className="text-[#FF5757] bg-[#FFFFFF] hover:bg-[#FFFFFF] border border-[#FF5757] focus:outline-none font-[500] rounded-[5px] text-[16px] text-medium px-10 py-2 text-center"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RemoveGuarantor;
